import { useState, useCallback } from 'react';

export const useModalManager = () => {
    const [activeModal, setActiveModal] = useState(null);
    const [modalData, setModalData] = useState(null);

    const openModal = useCallback((modalId, data = null) => {
        setActiveModal(modalId);
        setModalData(data);
    }, []);

    const closeModal = useCallback(() => {
        setActiveModal(null);
        setModalData(null);
    }, []);

    return {
        activeModal,
        modalData,
        openModal,
        closeModal,
    };
};
